module.exports = __webpack_public_path__ + "img/a-2.762fb48d.png";